module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_2_neg.58c94df3.png";